import { createUrl, formatSecondsToTime } from 'app/utils';
import formatDateFromUtcToTimezone from 'app/utils/formatDateFromUtcToTimezone';
import { CardSell, Flex, ListInfo, RichContent, Section2, Typography } from 'components';
import { StudentPracticeExamAssessmentStatusEnum, ExamsPagination } from 'features/exams';
import useExams from 'features/exams/useExams';
import { ProductsSidebarButton } from 'features/products';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';

const Details = () => {
  const { currentTheme } = useTheme();
  const { examUuid } = useParams();

  const { examsDetails, setExamsAction } = useExams();

  let subtitleLabel = '';

  let releaseDate = '';
  if (examsDetails?.releaseDate) {
    const releaseAt = formatDateFromUtcToTimezone(examsDetails?.releaseDate);
    releaseDate = releaseAt.format('DD/MM');
    subtitleLabel += `${releaseDate}`;
  }

  let closeDate = '';
  if (examsDetails?.closeDate) {
    closeDate = formatDateFromUtcToTimezone(examsDetails?.closeDate).format('DD/MM');
    subtitleLabel += ` ATÉ ${closeDate}`;
  }

  const hasButton =
    examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.StartedNotFinished ||
    examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Finished ||
    examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.ReleasedNotStarted;

  return (
    <>
      <ExamsPagination />

      <Flex flexGrow={0} my={{ m: 30, t: 50, d: 60 }}>
        <Section2 flexWrap={{ m: 'wrap', d: 'nowrap' }}>
          <Flex flexDirection="column" mr={{ d: 80 }}>
            <Typography type="type3" color="color50" upper>
              Avaliação
            </Typography>

            <Typography type="type6" color="color100" fontWeight="bold" mt={1}>
              {examsDetails?.name}
            </Typography>

            <Flex mt={4}>
              <RichContent defaultType="type2" currentTheme={currentTheme}>
                {examsDetails?.description}
              </RichContent>

              {examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.NotDone && (
                <Flex mt={{ m: 3, d: 5 }}>
                  <Typography color="alert_400" fontWeight="bold">
                    Aqui entra a mensagem do nasser
                  </Typography>
                </Flex>
              )}
            </Flex>
          </Flex>

          <Flex flexGrow={0} width={{ m: '100%', t: 370 }} flexDirection="column" flexShrink={0} mt={{ m: 30, d: 0 }}>
            {(examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.StartedNotFinished ||
              examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Finished ||
              examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.ReleasedNotStarted ||
              examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.NotDone ||
              examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.ToBeReleased ||
              examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Blocked) && (
              <ListInfo
                withButton={hasButton}
                width={370}
                list={[
                  {
                    icon: 'calendar',
                    label: 'Prazo para realizacão',
                    title: subtitleLabel || 'Sem prazo',
                  },
                  { icon: 'clockTimeFourOutline', label: 'Tempo de prova', title: formatSecondsToTime(examsDetails?.durationSeconds) },
                  {
                    icon: 'formatListBulleted',
                    label: 'total de questões',
                    title: `${examsDetails?.questionCount} ${examsDetails?.questionCount === 1 ? 'questão' : 'questões'}`,
                  },
                ]}
              />
            )}

            {examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.AvailableToBuy && (
              <CardSell
                labelTitle="AVALIAÇÃO"
                title={examsDetails?.name}
                labelSubTitle="ADQUIRA AGORA"
                subtitle="XX"
                footer="XXXX"
                placeholder="ADQUIRIR AVALIAÇÃO"
                onClick={() => alert('TOGGLE')}
              />
            )}

            {examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.ReleasedNotStarted && (
              <>
                <ProductsSidebarButton label="Iniciar avaliação" type="nolink" onClick={() => setExamsAction('start')} to="#" />
              </>
            )}

            {examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.StartedNotFinished && (
              <>
                <ProductsSidebarButton
                  label="Continuar"
                  type="internal"
                  to={createUrl('exams/assessment', [examUuid, examsDetails?.studentPracticeExamAssessment])}
                />
              </>
            )}

            {examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Finished && (
              <>
                <ProductsSidebarButton
                  label="Ver resultado"
                  type="external"
                  to={createUrl('exams/result', [examUuid, examsDetails?.studentPracticeExamAssessment])}
                />
              </>
            )}

            {examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Unavailabled && <>Unavailabled</>}
          </Flex>
        </Section2>
      </Flex>
    </>
  );
};

export default Details;
